export default [{
  path: '/mobile/mediaBind',
  name: 'mediaBindMobile',
  component: () => import('@/pages/mobile/mediaBindMobile/index'),
  meta: {
    auth: 'noAuth',
    spm: 2280,
  },
},
{
  path: '/mobile/confirmBind/:media',
  name: 'confirmBindMobile',
  component: () => import('@/pages/mobile/confirmBind/index'),
  meta: {
    auth: 'noAuth',
    spm: 2281,
  },
},
{
  path: '/mobile/bindKgFramePage',
  name: 'bindKgFramePage',
  component: () => import('@/pages/mobile/confirmBind/bindKgFramePage'),
  meta: {
    auth: 'noAuth',
  },
},
{
  path: '/mobile/bindResult/:media',
  name: 'bindResultMobile',
  component: () => import('@/pages/mobile/bindResult/index'),
  meta: {
    auth: 'noAuth',
    spm: 2282,
  },
},
];
